import { useTranslation } from 'react-i18next'
import { Stack, Typography, Chip, Divider } from '@mui/material'
import { formatPrice } from '../model/useMedicalActRecords'

export type MedicalActsTotalFooterProps = {
    totalRevenue: number
    compact?: boolean
}

export function MedicalActsTotalFooter({
    totalRevenue,
    compact = false,
}: MedicalActsTotalFooterProps) {
    const { t } = useTranslation()

    if (compact) {
        return (
            <Typography variant="caption" color="text.secondary" textAlign="right">
                {t('medicalAct.section.total', { defaultValue: 'Total' })}: {formatPrice(totalRevenue)}
            </Typography>
        )
    }

    return (
        <>
            <Divider />
            <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={2}>
                <Typography variant="subtitle1" fontWeight="bold">
                    {t('medicalAct.section.total', { defaultValue: 'Total' })}:
                </Typography>
                <Chip
                    label={formatPrice(totalRevenue)}
                    color="primary"
                    sx={{ fontWeight: 'bold' }}
                />
            </Stack>
        </>
    )
}
